import useChannels from "./useChannels";

export const useChannelById = (channelId: number) => {
    const channels = useChannels();

    return channels.find(({ id }) => id === channelId);
};
